import maplibregl, { StyleSpecification } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import { Ativo } from "../../api/m5";
import { WhitelabelConfig } from "../../config/whitelabel";

interface CamadaBase {
  id: string;
  nome: string;
  style: string | StyleSpecification;
}

const ESTILO_OSM: StyleSpecification = {
  version: 8,
  sources: {
    osm: {
      type: "raster",
      tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
      tileSize: 256,
      attribution: "&copy; OpenStreetMap contributors",
    },
  },
  layers: [{ id: "osm", type: "raster", source: "osm" }],
};

// Camadas de mapa base disponiveis. "Google" fica de fora por enquanto -
// MapLibre GL JS nao suporta o Google Maps nativamente (exigiria o SDK
// proprio do Google, com API key e cobranca separada).
function camadasBase(config: WhitelabelConfig): CamadaBase[] {
  return [
    { id: "maplibre", nome: "MapLibre (vetorial)", style: config.map.styleUrl },
    { id: "osm", nome: "OpenStreetMap (raster)", style: ESTILO_OSM },
  ];
}

export function renderAssetsMap(
  el: HTMLElement,
  config: WhitelabelConfig,
  ativos: Ativo[],
  layerAccess: string[] = [],
  aoClicarEstacao?: (ativo: Ativo) => void
): maplibregl.Map {
  const camadas = camadasBase(config).filter(
    (c) => layerAccess.length === 0 || layerAccess.includes(c.id)
  );
  const camadaInicial = camadas[0] || camadasBase(config)[0];

  const map = new maplibregl.Map({
    container: el,
    style: camadaInicial.style,
    center: [config.map.centroInicial.lon, config.map.centroInicial.lat],
    zoom: config.map.centroInicial.zoom,
  });

  map.addControl(new maplibregl.NavigationControl(), "top-right");

  function adicionarMarcadores() {
    for (const ativo of ativos) {
      if (!ativo.geom || ativo.geom.type !== "Point") continue;
      const [lon, lat] = ativo.geom.coordinates;

      const marker = new maplibregl.Marker({ color: config.theme.colors.primary }).setLngLat([lon, lat]).addTo(map);

      // Sem Popup do MapLibre de proposito - o painel de detalhes da estacao
      // vive fora do mapa (ver mapa.ts), pra poder ter altura fixa com
      // rolagem propria em vez de crescer maior que a pagina.
      if (aoClicarEstacao) {
        marker.getElement().addEventListener("click", (e) => {
          e.stopPropagation();
          aoClicarEstacao(ativo);
        });
      }
    }
  }

  map.on("load", adicionarMarcadores);

  if (camadas.length > 1) {
    const seletor = document.createElement("select");
    seletor.className = "mapa-seletor-camada";
    seletor.style.cssText =
      "position:absolute; top:10px; left:10px; z-index:1; padding:6px 8px; border-radius:6px; border:1px solid #ccc;";
    seletor.innerHTML = camadas.map((c) => `<option value="${c.id}">${c.nome}</option>`).join("");
    seletor.addEventListener("change", () => {
      const camada = camadas.find((c) => c.id === seletor.value);
      if (camada) map.setStyle(camada.style);
    });
    el.appendChild(seletor);
  }

  return map;
}
